// SEC-012: theme.css was imported here for side effects, but this module is shared by the
// PWA and the extension builds, which need different css handling (file-loader emit vs
// style-loader injection). The import now lives at each build entry that needs it:
// packages/pwa/src/index.ts and packages/extension/src/app.ts.
export const narrowWidth = 700;
export const wideWidth = 1200;
